import { createReducer, on } from '@ngrx/store';
import { ConfigActions } from './config.action';
import { initialConfigState } from './config.state';

export const configReducer = createReducer(
  initialConfigState,

  on(ConfigActions.getConfigSuccess, (state, config) => {
    return {
      ...state,
      ...config,
    };
  }),

  on(ConfigActions.setDarkModeStatus, (state, { status }) => {
    return {
      ...state,
      darkModeEnabled: status,
    };
  }),

  on(ConfigActions.setWebappMode, (state) => {
    return {
      ...state,
      webappMode: true,
    };
  }),
);
